<nav class="navbar navbar-expand-lg align-items-lg-center container-p-x" [ngClass]="currentBg()">

  <!-- Brand -->
  <a routerLink="/" class="navbar-brand"></a>

  <!-- Sidenav toggle -->
  <div class="navbar-nav align-items-lg-center mr-auto mr-lg-4" *ngIf="sidenavToggle">
    <a class="nav-item nav-link px-0 ml-2" href="javascript:void(0)" (click)="toggleSidenav()">
      <i class="ion ion-md-menu text-large align-middle"></i>
    </a>
  </div>

  <!-- Navbar toggle -->
  <button class="navbar-toggler" type="button" (click)="isExpanded = !isExpanded">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="navbar-collapse collapse" [ngbCollapse]="!isExpanded">
    <div class="navbar-nav align-items-lg-center">
<!--      <div class="nav-item"><a class="nav-link" href="#">Link 1</a></div>-->
<!--      <div class="nav-item"><a class="nav-link" href="#">Link 2</a></div>-->
    </div>

    <div class="navbar-nav align-items-lg-center ml-auto">
      <!-- Divider -->
      <div class="nav-item d-none d-lg-block text-big font-weight-light line-height-1 opacity-25 mr-3 ml-1">|</div>

      <div ngbDropdown [placement]="isRTL ? 'bottom-left' : 'bottom-right'" class="demo-navbar-user nav-item">
        <a ngbDropdownToggle class="nav-link" href="javascript:void(0)">
          <span class="d-inline-flex flex-lg-row-reverse align-items-center align-middle">
<!--            <img src="assets/img/avatars/1.png" alt class="d-block ui-w-30 rounded-circle">-->
            <i class="lnr d-block lnr-user"></i>
            <span class="px-1 mr-lg-2 ml-2 ml-lg-0">{{getUserFullname()}}</span>
          </span>
        </a>
        <div ngbDropdownMenu [class.dropdown-menu-right]="!isRTL">
          <a href="javascript:void(0)" class="dropdown-item"><i class="ion ion-ios-person text-lightest"></i> &nbsp; My profile</a>
          <a href="javascript:void(0)" class="dropdown-item"><i class="ion ion-ios-mail text-lightest"></i> &nbsp; Messages</a>
          <a href="javascript:void(0)" class="dropdown-item"><i class="ion ion-md-settings text-lightest"></i> &nbsp; Account settings</a>
          <div class="dropdown-divider"></div>
          <a href="javascript:void(0)" class="dropdown-item" (click)="logout()"><i class="ion ion-ios-log-out text-danger"></i> &nbsp; Log Out</a>
        </div>
      </div>
    </div>

  </div>

</nav>
